// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"244":"5ef3f568","309":"64ecf88e","338":"6552f10a","405":"d3bdc3e6","426":"8c58b5c3","447":"121f9d4d","591":"8145bdd0","602":"d2bf908a","608":"cceb7faf","698":"c1cd5103","784":"fc73d48f"}[chunkId] + ".js";
};